import * as React from 'react';
import { Markup } from 'interweave';
import * as styleSheet from '../styles';
import { Box, Text } from '@enaep-ng/benchmark';

const SecondaryTitle = (props: { content: string, style?: React.CSSProperties  }) => {
  return (
    <Box sx={styleSheet.secondaryTitleStyled} style={props.style}>
      <Markup content={props.content} />
    </Box>
  );
};

const Title = (props: { content: string, style?: React.CSSProperties }) => {
  return (
    <Box sx={styleSheet.titleStyled} style={props.style}>
      <Markup content={props.content} />
    </Box>
  );
};


const SubTitle = (props: { content: string, style?: React.CSSProperties}) => {
  return (
    <Box sx={styleSheet.subTitleStyled} style={props.style}>
      <Markup content={props.content} />
    </Box>
  );
};

const ErrorTitle = (props: { content: string, style?: React.CSSProperties }) => {
  return (
    <Box sx={styleSheet.errorTitleStyled} style={props.style}>
      <Markup content={props.content} />
    </Box>
  );
};
export { Title, SubTitle,ErrorTitle,SecondaryTitle};
